import axios from '../axiosConfig';

export interface ApplicationBuildInfo {
  applicationVersion: string;
  buildNumber: string;
}

interface ApplicationInfoResponse extends ApplicationBuildInfo {
  environment: string;
  frontBuildId?: string | null;
  frontCommit?: string | null;
  apiBuildId?: string | null;
  apiCommit?: string | null;
  deployedAt?: string | null;
}

export async function fetchApiApplicationInfo(): Promise<ApplicationBuildInfo | null> {
  try {
    const { data } = await axios.get<ApplicationInfoResponse>('/application-info');
    const applicationVersion = String(data?.applicationVersion || '').trim();
    const buildNumber = String(data?.buildNumber || '').trim();

    if (!applicationVersion || !buildNumber) {
      return null;
    }

    return { applicationVersion, buildNumber };
  } catch (_error) {
    return null;
  }
}
